import { toast } from 'react-toastify'

export const showPendingToast = (requestId: string, message: string) => {
  toast.loading(message, { autoClose: false, toastId: requestId })
}

export const successToast = (requestId: string, message: string) => {
  toast.update(requestId, {
    type: toast.TYPE.SUCCESS,
    autoClose: 5000,
    render: message,
    isLoading: false,
  })
}

export const failToast = (requestId: string, message: string) => {
  toast.update(requestId, {
    type: toast.TYPE.ERROR,
    autoClose: 5000,
    render: message,
    isLoading: false,
  })
}
